import React, { useState, useEffect } from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaWhatsapp, FaClock } from 'react-icons/fa';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
    alert('Thank you for your inquiry! We will contact you soon.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      service: '',
      message: ''
    });
  };

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="contact-hero-overlay"></div>
        <div className="contact-hero-content">
          <h1>Get in Touch</h1>
          <p>
            Contact us today for Audio Visual Automation and Home Theatre Installation Service. 
            Let's discuss how we can transform your space.
          </p>
        </div>
      </section>

      {/* Contact Info & Form Section */}
      <section className="contact-main">
        <div className="container">
          <div className="contact-grid">
            {/* Contact Information */}
            <div className="contact-info-section">
              <h2>Contact Information</h2>
              <p className="contact-intro">
                F&H Audio Solutions LLP is one of the premier Home Audio Visual Automation Consultants 
                and Home Theatre Installation Service in India. Our office is located in Guntur, 
                Andhra Pradesh, but we serve clients across India.
              </p>

              <div className="contact-details">
                <div className="contact-item">
                  <div className="contact-icon">
                    <FaPhone />
                  </div>
                  <div className="contact-text">
                    <h3>Phone</h3>
                    <a href="tel:+919876543210">+91 98765 43210</a>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-icon">
                    <FaEnvelope />
                  </div>
                  <div className="contact-text">
                    <h3>Email</h3>
                    <a href="mailto:info@fhaudio.in">info@fhaudio.in</a>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-icon">
                    <FaMapMarkerAlt />
                  </div>
                  <div className="contact-text">
                    <h3>Office Address</h3>
                    <p>
                      #22-11-120, first floor, thunuguntlavari street,<br />
                      chendanabrothers side line, Lalapet,<br />
                      Guntur, Andhra Pradesh 522003
                    </p>
                    <a 
                      href="https://maps.app.goo.gl/CuKNRpVu9hTuXz6SA" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      style={{ color: '#d4af37', marginTop: '0.5rem', display: 'inline-block' }}
                    >
                      View on Map →
                    </a>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-icon">
                    <FaWhatsapp />
                  </div>
                  <div className="contact-text">
                    <h3>WhatsApp</h3>
                    <a href="https://wa.me/919876543210" target="_blank" rel="noopener noreferrer">
                      +91 98765 43210
                    </a>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-icon">
                    <FaClock />
                  </div>
                  <div className="contact-text">
                    <h3>Business Hours</h3>
                    <p>
                      Monday - Saturday: 10:00 AM - 7:00 PM<br />
                      Sunday: By Appointment Only
                    </p>
                  </div>
                </div>
              </div>

              <div className="appointment-notice">
                <strong>Important Note:</strong> Without a prior appointment, visitation to our location 
                is not possible. To avoid any inconvenience, kindly schedule your appointment in advance. 
                Thank you for your cooperation!
              </div>
            </div>

            {/* Contact Form */}
            <div className="contact-form-section">
              <h2>Send Us a Message</h2>
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Full Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Enter your name"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="Enter your email"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Phone Number *</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    placeholder="Enter your phone number"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="service">Service Interested In</label>
                  <select
                    id="service"
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                  >
                    <option value="">Select a service</option>
                    <option value="hifi">Hi-Fi Audio System</option>
                    <option value="hometheater">Home Theater</option>
                    <option value="automation">Home Automation</option>
                    <option value="consultation">Consultation</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="message">Your Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="5"
                    placeholder="Tell us about your project requirements..."
                  ></textarea>
                </div>

                <button type="submit" className="btn btn-primary btn-submit">
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="contact-map">
        <div className="map-container">
          <iframe
            title="MARK AUDIO - F&H Audio Solutions Location"
            // src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3825.708287756!2d80.42850757520365!3d16.31755308432664!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a4a759b0a7e4c53%3A0x7e79c2becbf25b6a!2sMARK%20AUDIO!5e0!3m2!1sen!2sin!4v1737381000000!5m2!1sen!2sin"
           src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3829.6079153280757!2d80.4459677!3d16.2918536!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a4a759f3a55efaf%3A0x8b141f36d3f740e3!2sMARK%20AUDIO!5e0!3m2!1sen!2sin!4v1768922303358!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>
    </div>
  );
};

export default Contact;
